export enum PermitType {
    CoordinationPermit = "CoordinationPermit",
    DivingPermit = "DivingPermit",
    EnergyHarbourPermit = "EnergyHarbourPermit",
    HotWorkOnShipPermit = "HotWorkOnShipPermit",
    HullCleaningPermit = "HullCleaningPermit",
    MaritimeEvent = "MaritimeEvent",
    ShipRepairsPermit = "ShipRepairsPermit",
    UnderWaterWorkPermit = "UnderWaterWorkPermit",
    GeneralDepartmentPermit = "GeneralDepartmentPermit"
}

export enum PermitTypeFilter {
    CoordinationPermit = "CoordinationPermit",
    DivingPermit = "DivingPermit",
    EnergyHarbourPermit = "EnergyHarbourPermit",
    HotWorkOnShipPermit = "HotWorkOnShipPermit",
    HullCleaningPermit = "HullCleaningPermit",
    MaritimeEvent_General = "MaritimeEvent_General",
    MaritimeEvent_CraneService = "MaritimeEvent_CraneService",
    MaritimeEvent_CraneArmLowered = "MaritimeEvent_CraneArmLowered",
    ShipRepairsPermit = "ShipRepairsPermit",
    UnderWaterWorkPermit = "UnderWaterWorkPermit",
    GeneralDepartmentPermit = "GeneralDepartmentPermit"
}

export enum PermitCategory {
    HotWorkCategoryOne = "HotWorkCategoryOne",
    HotWorkCategoryTwo = "HotWorkCategoryTwo",
    HotWorkCategoryThree = "HotWorkCategoryThree",
    ColdWork = "ColdWork",
    WorkWithRiskOfFlammableLiquidOrGas = "WorkWithRiskOfFlammableLiquidOrGas",
    Other = "Other"
}

export enum WorkPermitTagType {
    ContactPerson = "ContactPerson",
    WorkLeaderPhoneNumber = "WorkLeaderPhoneNumber",
    ShipName = "ShipName"
}

export enum ShapeType {
    Polygon = "Polygon",
    LineString = "LineString",
    Point = "Point"
}

export enum CodeRole {
    SystemOwner = "SystemOwner",
    Admin = "Admin",
    InternalCaseManager = "InternalCaseManager",
    ExternalCaseManager = "ExternalCaseManager",
    InternalDirectorFlammableProduct = "InternalDirectorFlammableProduct",
    ExternalDirectorFlammableProduct = "ExternalDirectorFlammableProduct",
    InternalObserver = "InternalObserver",
    ExternalObserver = "ExternalObserver"
}

export enum SignatureType {
    PermitProvider = "PermitProvider",
    PowerOffResponsibleElectrician = "PowerOffResponsibleElectrician",
    PowerOffWorkLeader = "PowerOffWorkLeader",
    PowerOffDirectorFlammableProduct = "PowerOffDirectorFlammableProduct",
    PowerOffPortOfficer = "PowerOffPortOfficer",
    PowerOffExternalDirectorFlammableProduct = "PowerOffExternalDirectorFlammableProduct",
    PowerOnResponsibleElectrician = "PowerOnResponsibleElectrician",
    PowerOnWorkLeader = "PowerOnWorkLeader",
    PowerOnDirectorFlammableProduct = "PowerOnDirectorFlammableProduct",
    PowerOnPortOfficer = "PowerOnPortOfficer",
    PowerOnExternalDirectorFlammableProduct = "PowerOnExternalDirectorFlammableProduct",
    CraneOperator = "CraneOperator",
    HotWorkInternalDirectorFlammableProduct = "HotWorkInternalDirectorFlammableProduct",
    HotWorkExternalDirectorFlammableProduct = "HotWorkExternalDirectorFlammableProduct",
    SafetyAgreementPermitSeeker = "SafetyAgreementPermitSeeker",
    PermitAgreementPermitProvider = "PermitAgreementPermitProvider",
    PermitAgreementPermitSeeker = "PermitAgreementPermitSeeker",
    IsFinishedPermitSeeker = "IsFinishedPermitSeeker",
    IsFinishedPermitProvider = "IsFinishedPermitProvider",
    SafeHarbourEducationControlled = "SafeHarbourEducationControlled",
    APMTInformationConfirmation = "APMTInformationConfirmation"
}

export enum MethodOfWork {
    Welding = "Welding",
    GrindingDisc = "GrindingDisc",
    Cutting = "Cutting",
    Soldering = "Soldering",
    HotAir = "HotAir",
    AsphaltPot = "AsphaltPot",
    TigerSaw = "TigerSaw",
    Other = "Other"
}

export enum CodeStatus {
    New = "New",
    Registered = "Registered",
    Accepted = "Accepted",
    Archived = "Archived",
    Rejected = "Rejected"
}

export enum RadioButtonOption {
    Yes = "yes",
    No = "no",
    NotApplicable = "notApplicable",
    None = "none" // If a property has value "None", then none of the available options have been selected.
}

export enum HarbourOffice {
    Skarvik = "Skarvik",
    Torshamnen = "Torshamnen"
}

export enum OrderedBy {
    PortOfGothenburg = "PortOfGothenburg",
    Other = "Other"
}

export enum CounterSignatureRequestStatus {
    NotSigned = "NotSigned",
    Signed = "Signed",
    Cancelled = "Cancelled"
}

export enum CounterSignatureLocation {
    HotWork = "HotWork",
    ElectricFencePowerOn = "ElectricFencePowerOn",
    ElectricFencePowerOff = "ElectricFencePowerOff"
}

export enum Location {
    General = "General",
    EnergyHarbour = "EnergyHarbour",
    APMT = "APMT"
}

export enum WorkOrigin {
    Quay = "Quay",
    Boat = "Boat",
    Raft = "Raft",
    Pram = "Pram"
}

export enum CodeDepartment {
    EnergyHarbour,
    PortControl,
    OtherDepartment
}

export enum WorkPermitSortProperty {
    Status = "Status",
    SequenceIdentifier = "SequenceIdentifier",
    StartDate = "StartDate",
    EndDate = "EndDate",
    Positions = "Positions",
    CompanyNormalizedName = "CompanyNormalizedName",
    DepartmentName = "DepartmentName",
    Entrepreneur = "Entrepreneur",
    Description = "Description"
}

export enum MaritimeEventType {
    General = "General",
    CraneService = "CraneService",
    CraneArmLowered = "CraneArmLowered"
}

export enum HotWorkSection {
    HotWork = "HotWork",
    HotWorkCategoryOne = "HotWorkCategoryOne",
    HotWorkCategoryTwo = "HotWorkCategoryTwo",
    HotWorkCategoryThree = "HotWorkCategoryThree"
}

const permitCategoryOrder = {
    [PermitCategory.Other]: 0,
    [PermitCategory.ColdWork]: 1,
    [PermitCategory.HotWorkCategoryThree]: 2,
    [PermitCategory.HotWorkCategoryTwo]: 3,
    [PermitCategory.HotWorkCategoryOne]: 4,
    [PermitCategory.WorkWithRiskOfFlammableLiquidOrGas]: 5
} as const;


export function orderPermitCategory(permitCategory: PermitCategory[]): PermitCategory[] {
    return permitCategory.sort((a, b) => permitCategoryOrder[a] - permitCategoryOrder[b]);
}

export function getHighestPermitCategory(permitCategory: PermitCategory[]): PermitCategory {
    if (permitCategory.length === 0) {
        console.error("Attempted to get highest permit category from empty array");
        return PermitCategory.Other;
    }

    const orderedCategories = orderPermitCategory(permitCategory);
    return orderedCategories[orderedCategories.length - 1];
}
